var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMail = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 2.25A1.75 1.75 0 0 0 1.25 4v8c0 .966.784 1.75 1.75 1.75h10A1.75 1.75 0 0 0 14.75 12V4A1.75 1.75 0 0 0 13 2.25H3zM2.75 4A.25.25 0 0 1 3 3.75h10a.25.25 0 0 1 .25.25v.46L8 6.21 2.75 4.46V4zm0 2.04V12c0 .138.112.25.25.25h10a.25.25 0 0 0 .25-.25V6.04L8 7.79 2.75 6.04z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMail);
export default ForwardRef;